/** 判断元素是否在视口内 */
function isElementInViewportWithCondition(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  // 情况1：元素小于或等于视口 - 检查元素是否完全在视口内
  if (rect.height <= windowHeight && rect.width <= windowWidth) {
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= windowHeight &&
      rect.right <= windowWidth
    );
  }
  // 情况2：元素大于视口 - 元素和视口有交集 且 元素底部在视口底部之上
  else {
    // 判断是否有交集（水平和垂直方向都有重叠）
    const hasHorizontalIntersection = rect.left < windowWidth && rect.right > 0;
    const hasVerticalIntersection = rect.top < windowHeight && rect.bottom > 0;
    const hasIntersection = hasHorizontalIntersection && hasVerticalIntersection;

    // 判断元素底部是否在视口底部之上（元素的底部 <= 视口底部）
    const isBottomAboveViewportBottom = rect.bottom <= windowHeight;

    return hasIntersection && isBottomAboveViewportBottom;
  }
}

/**
 * 利用监听器去判断元素是否在视口内，并触发回调函数
 * @param {void ()} callback 
 * @returns 
 */
function createObserverToListenElementInViewport(callback) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const rect = entry.boundingClientRect;
      const windowHeight = window.innerHeight;

      // 判断元素是否大于视口
      const isLargerThanViewport = rect.height > windowHeight;

      if (isLargerThanViewport) {
        // 大元素：检查是否有交集且底部在视口底部之上
        const hasIntersection = entry.intersectionRatio > 0;
        const isBottomAboveViewportBottom = rect.bottom <= windowHeight;

        if (hasIntersection && isBottomAboveViewportBottom) {
          // console.log('大元素满足条件');
          // 触发自定义事件或回调
          callback();
        }
      } else {
        // 小元素：检查是否完全可见
        if (entry.intersectionRatio === 1) {
          // console.log('小元素完全可见');
          callback();
        }
      }
    });
  }, {
    threshold: [0, 1] // 监听0和1两个阈值
  });

  return observer;
}

class FitDayBanner extends HTMLElement {
  constructor() {
    super();
    this._onClickButton = this.onClickButton.bind(this);

    this.autoPlay = this.getAttribute('data-auto-play') === 'true';
    this.autoPlayDelay = Number(this.getAttribute('data-auto-play-delay'));

    /** 用户自己选择了下拉框 */
    this.customSelected = false;

    if (isNaN(this.autoPlayDelay)) {
      this.autoPlayDelay = 3000;
    }
  }

  connectedCallback() {
    this.swiperContainer = this.querySelector('.swiper');
    this.button = this.querySelector('[data-banner-button]');
    this.init();
  }

  init() {
    const swiperOptions = {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      speed: 500,
      resizeObserver: true,
      observeParents: true,
    };

    if (this.autoPlay) {
      swiperOptions.autoplay = {
        delay: this.autoPlayDelay,
        disableOnInteraction: false,
      };
    }

    this.swiper = new Swiper(this.swiperContainer, swiperOptions);
    this.button?.addEventListener('click', this._onClickButton);
  }

  disconnectedCallback() {
    this.swiper?.destroy();
    this.button?.removeEventListener('click', this._onClickButton);
  }

  /**
   * Banner 点击按钮，滚动到指定位置
   */
  onClickButton() {
    // 滚动到该元素
    const el = document.querySelector('[data-banner-button-scroll-position]');
    if (!el) return;
    const headerHeight = document.querySelector('.site-header')?.clientHeight ?? 0;
    const navigatorHeight = document.querySelector('.fit-day-navigator')?.clientHeight ?? 0;
    window.scrollTo({
      top: $(el).offset().top - headerHeight - navigatorHeight + 2,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('fit-day-banner')) {
  customElements.define('fit-day-banner', FitDayBanner);
}

class FitDayNavigator extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var scrollEventLock = false;
    const $headerEl = $('.site-header');
    const $stickyBarEl = $(this);

    const clearActive = () => {
      const items = $('.fit-day-navigator__item');
      items.removeClass('active');
    };

    $('.fit-day-navigator__item').click(function (e) {
      const $el = $(e.currentTarget);
      const el = e.currentTarget;
      e.preventDefault();
      if (scrollEventLock) return;
      var goto = $el.attr('data-jump-scroll-to-name');
      if (!goto) return;
      clearActive();
      $el.addClass('active');
      let scrollTop = 0;
      scrollEventLock = true;
      // offset
      try {
        scrollTop = $(`[data-jump-scroll-name="${goto}"]`).offset()?.top ?? 0;
        // 由 sticky 元素导致的偏移量
        let offsetHeight = $headerEl.height() + $stickyBarEl.height();
        scrollTop > offsetHeight ? (scrollTop -= offsetHeight) : (scrollTop = 0);
        window.scroll({
          top: scrollTop,
          behavior: 'smooth',
        });
        setTimeout(() => (scrollEventLock = false), 700);
      } catch (e) {
        console.error(e);
      }
      // 移动端，选项滚动进视图
      const container = document.querySelector('.fit-day-navigator__list');
      const containerLeft = container.scrollLeft;
      const containerWidth = container.clientWidth;
      const itemLeft = el.offsetLeft;
      const itemWidth = el.offsetWidth;
      // console.log(containerLeft, containerWidth, itemLeft, itemWidth);
      if (itemLeft < containerLeft || itemLeft + itemWidth > containerLeft + containerWidth) {
        container.scroll({
          left: itemLeft,
          behavior: 'smooth',
        });
      }
    });

    var ids = [...this.querySelectorAll('[data-jump-scroll-to-name]')].map((item) =>
      item.getAttribute('data-jump-scroll-to-name')
    );

    window.addEventListener('scroll', (e) => {
      setTimeout(() => {
        updateStickyBarTop();
      });
      const windowScrollTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );
      const offsetWindowScrollTop = windowScrollTop;
      if (scrollEventLock) return;
      try {
        for (let i = 0; i < ids.length; i++) {
          const offset =
            ($(`[data-jump-scroll-name="${ids[i]}"]`).offset()?.top ?? Infinity) -
            ($headerEl.height() + $stickyBarEl.height() + 2);
          if (offsetWindowScrollTop > offset) {
            clearActive();
            $('.fit-day-navigator__item')[i].classList.add('active');
          }
        }
      } catch (e) {
        console.error(e);
      }
    });

    function updateStickyBarTop() {
      const headerHeight = $headerEl.height();
      $stickyBarEl.css('top', headerHeight);
    }
    updateStickyBarTop();
  }
}

if (!customElements.get('fit-day-navigator')) {
  customElements.define('fit-day-navigator', FitDayNavigator);
}

// component-fit-day-events.js
class FitDayEvents extends HTMLElement {
  /** @type {(slide: HTMLElement) => void} */
  inViewCallback = null;

  // 记录已触发的轮播图索引
  prevCallbackIndexList = new Set();

  constructor() {
    super();
    this.swiper = null;
    this.tabs = [];
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  /**
   * @param {(slide: HTMLElement) => void} callback 
   */
  setInViewCallback(callback) {
    this.inViewCallback = callback;
  }

  init() {
    this.initElements();
    this.initSwiper();
    this.bindEvents();
  }

  initElements() {
    // 获取内部元素
    this.tabContainer = this.querySelector('.fit-day-events__tabs');
    this.tabs = Array.from(this.querySelectorAll('.fit-day-events__tab'));
    this.sliderWrapper = this.querySelector('.fit-day-events__slider');

    // 获取配置
    this.autoPlay = this.dataset.autoPlay === 'true';
    this.autoPlayDelay = parseInt(this.dataset.autoPlayDelay) || 5000;
  }

  initSwiper() {
    if (!this.sliderWrapper) {
      return;
    }

    // 检查 Swiper 是否已加载
    if (typeof Swiper === 'undefined') {
      console.error('Swiper.js is not loaded');

      // 尝试延迟加载
      setTimeout(() => {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          console.error('Swiper.js still not loaded after delay');
        }
      }, 100);
      return;
    }

    // 如果 Swiper 已存在，先销毁
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    const swiperOptions = {
      slidesPerView: 'auto',
      loop: true,
      speed: 500,
      resizeObserver: true,
      observeParents: true,
      centeredSlides: true,
      navigation: {
        nextEl: this.querySelector('.fit-day-events__nav--next'),
        prevEl: this.querySelector('.fit-day-events__nav--prev'),
      },
      pagination: {
        el: this.querySelector('.fit-day-events__pagination'),
        clickable: true,
      },
      on: {
        init: this.onSwiperInit.bind(this),
        slideChange: this.onSlideChange.bind(this),
        slideChangeTransitionEnd: this.onSlideChangeEnd.bind(this),
        resize: this.onSwiperResize.bind(this),
      }
    };

    // 添加自动播放配置
    if (this.autoPlay) {
      swiperOptions.autoplay = {
        delay: this.autoPlayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    try {
      this.swiper = new Swiper(this.sliderWrapper, swiperOptions);
      console.log('Swiper initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Swiper:', error);
    }
  }

  bindEvents() {
    // Tab 点击事件
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.swiper) {
          this.swiper.slideToLoop(index);
          this.updateTabs(index);
        }
      });
    });

    this.inViewObserver = createObserverToListenElementInViewport(this.handleInViewCallback.bind(this));
    this.inViewObserver.observe(this.sliderWrapper);
  }

  /**
   * 轮播图滚动进视图触发
   */
  handleInViewCallback() {
    if (this.inViewCallback && !this.prevCallbackIndexList.has(this.swiper.realIndex)) {
      // 添加到记录 
      this.prevCallbackIndexList.add(this.swiper.realIndex);
      // 触发回调
      this.inViewCallback(this.swiper.slides[this.swiper.activeIndex]);
    }
  }

  onSwiperInit() {
    // 初始化后更新 Tab 状态
    if (this.swiper) {
      this.updateTabs(this.swiper.realIndex);

      // 确保初始 Tab 在移动端可见
      if (this.isMobile && this.tabs.length > 0) {
        const activeTab = this.tabs[this.swiper.realIndex];
        if (activeTab) {
          this.scrollTabIntoView(activeTab);
        }
      }
    }
  }

  onSlideChange() {
    // 幻灯片切换时更新 Tab
    if (this.swiper) {
      this.updateTabs(this.swiper.realIndex);

      // 如果轮播图完全在视图内，则手动触发一次 InView
      if (isElementInViewportWithCondition(this.sliderWrapper)) {
        this.handleInViewCallback();
      }
    }
  }

  onSlideChangeEnd() {
    // 幻灯片切换结束后，确保 Tab 在移动端可见
    if (this.isMobile && this.swiper && this.tabs.length > 0) {
      const activeTab = this.tabs[this.swiper.realIndex];
      if (activeTab) {
        this.scrollTabIntoView(activeTab);
      }
    }
  }

  onSwiperResize() {
    this.isMobile = window.innerWidth <= 768;
  }

  updateTabs(activeIndex) {
    // 更新所有 Tab 的激活状态
    this.tabs.forEach((tab, index) => {
      const isActive = index === activeIndex;

      tab.classList.toggle('fit-day-events__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }


  scrollTabIntoView(tab) {
    if (!this.tabContainer || !tab) return;

    const containerWidth = this.tabContainer.offsetWidth;
    const tabLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;

    // 计算滚动位置使 Tab 居中
    const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);

    this.tabContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  reinitSwiper() {
    this.initSwiper();
  }

  cleanup() {
    // 清理 Swiper 实例
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.inViewObserver?.disconnect();
  }

  // 公共 API 方法
  nextSlide() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  goToSlide(index) {
    if (this.swiper && index >= 0 && index < this.swiper.slides.length) {
      this.swiper.slideToLoop(index);
    }
  }

  get activeIndex() {
    return this.swiper ? this.swiper.realIndex : 0;
  }

  get slidesCount() {
    return this.swiper ? this.swiper.slides.length : 0;
  }
}

if (!customElements.get('fit-day-events')) {
  customElements.define('fit-day-events', FitDayEvents);
}
// component-fit-day-products.js
class FitDayProducts extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.tabs = [];
    this.isMobile = window.innerWidth <= 768;
    this._reinitSwiper = this.reinitSwiper.bind(this);
    this.isMobileMQL = window.matchMedia(`(max-width: 768px)`);
  }

  // 观察的属性
  static get observedAttributes() {
    return ['data-auto-play', 'data-auto-play-delay'];
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    console.log(`Attribute ${name} changed from ${oldValue} to ${newValue}`);
    // 重新初始化 Swiper 如果相关属性发生变化
    if (name === 'data-auto-play' || name === 'data-auto-play-delay') {
      this.reinitSwiper();
    }
  }

  init() {
    this.initElements();
    this.initSwiper();
    this.bindEvents();
  }

  initElements() {
    // 获取内部元素
    this.tabContainer = this.querySelector('.fit-day-products__tabs');
    this.tabs = Array.from(this.querySelectorAll('.fit-day-products__tab'));
    this.sliderWrapper = this.querySelector('.fit-day-products__slider');

    // 获取配置
    this.autoPlay = this.dataset.autoPlay === 'true';
    this.autoPlayDelay = parseInt(this.dataset.autoPlayDelay) || 5000;
  }

  initSwiper() {
    if (!this.sliderWrapper) {
      return;
    }

    // 检查 Swiper 是否已加载
    if (typeof Swiper === 'undefined') {
      console.error('Swiper.js is not loaded');

      // 尝试延迟加载
      setTimeout(() => {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          console.error('Swiper.js still not loaded after delay');
        }
      }, 100);
      return;
    }

    // 如果 Swiper 已存在，先销毁
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    const isMobile = this.isMobileMQL.matches;

    const swiperOptions = {
      slidesPerView: 'auto',
      allowTouchMove: isMobile,
      loop: isMobile,
      speed: 500,
      resizeObserver: true,
      observeParents: true,
      navigation: {
        nextEl: this.querySelector('.fit-day-products__nav--next'),
        prevEl: this.querySelector('.fit-day-products__nav--prev'),
      },
      pagination: {
        el: this.querySelector('.fit-day-products__pagination'),
        clickable: true,
      },
      on: {
        init: this.onSwiperInit.bind(this),
        slideChange: this.onSlideChange.bind(this),
        slideChangeTransitionEnd: this.onSlideChangeEnd.bind(this),
        resize: this.onSwiperResize.bind(this),
      },
    };

    // 添加自动播放配置
    if (this.autoPlay) {
      swiperOptions.autoplay = {
        delay: this.autoPlayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    try {
      this.swiper = new Swiper(this.sliderWrapper, swiperOptions);
      console.log('Swiper initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Swiper:', error);
    }
  }

  bindEvents() {
    // Tab 点击事件
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.swiper) {
          this.swiper.slideToLoop(index);
          this.updateTabs(index);
        }
      });
    });
    this.isMobileMQL.addEventListener('change', this._reinitSwiper);
  }

  onSwiperInit() {
    // 初始化后更新 Tab 状态
    if (this.swiper) {
      this.updateTabs(this.swiper.realIndex);

      // 确保初始 Tab 在移动端可见
      if (this.isMobile && this.tabs.length > 0) {
        const activeTab = this.tabs[this.swiper.realIndex];
        if (activeTab) {
          this.scrollTabIntoView(activeTab);
        }
      }
    }
  }

  onSlideChange() {
    // 幻灯片切换时更新 Tab
    if (this.swiper) {
      this.updateTabs(this.swiper.realIndex);
    }
  }

  onSlideChangeEnd() {
    // 幻灯片切换结束后，确保 Tab 在移动端可见
    if (this.isMobile && this.swiper && this.tabs.length > 0) {
      const activeTab = this.tabs[this.swiper.realIndex];
      if (activeTab) {
        this.scrollTabIntoView(activeTab);
      }
    }
  }

  onSwiperResize() {
    this.isMobile = window.innerWidth <= 768;
  }

  updateTabs(activeIndex) {
    // 更新所有 Tab 的激活状态
    this.tabs.forEach((tab, index) => {
      const isActive = index === activeIndex;

      tab.classList.toggle('fit-day-products__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }

  scrollTabIntoView(tab) {
    if (!this.tabContainer || !tab) return;

    const containerWidth = this.tabContainer.offsetWidth;
    const tabLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;

    // 计算滚动位置使 Tab 居中
    const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);

    this.tabContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  reinitSwiper() {
    console.log(`reinitSwiper for ${this.tagName}`);
    this.initSwiper();
  }

  cleanup() {
    // 清理 Swiper 实例
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.isMobileMQL.removeEventListener('change', this._reinitSwiper);
  }

  // 公共 API 方法
  nextSlide() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  goToSlide(index) {
    if (this.swiper && index >= 0 && index < this.swiper.slides.length) {
      this.swiper.slideToLoop(index);
    }
  }

  get activeIndex() {
    return this.swiper ? this.swiper.realIndex : 0;
  }

  get slidesCount() {
    return this.swiper ? this.swiper.slides.length : 0;
  }
}

if (!customElements.get('fit-day-products')) {
  customElements.define('fit-day-products', FitDayProducts);
}

// component-fit-day-gallery.js
class FitDayGallery extends HTMLElement {

  constructor() {
    super();
    this.swiper = null;
    this.tabs = [];
  }

  // 观察的属性
  static get observedAttributes() {
    return ['data-auto-play', 'data-auto-play-delay'];
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    console.log(`Attribute ${name} changed from ${oldValue} to ${newValue}`);
    // 重新初始化 Swiper 如果相关属性发生变化
    if (name === 'data-auto-play' || name === 'data-auto-play-delay') {
      this.reinitSwiper();
    }
  }

  init() {
    this.initElements();
    this.initSwiper();
    this.bindEvents();
  }

  initElements() {
    // 获取内部元素
    this.tabContainer = this.querySelector('.fit-day-gallery__tabs');
    this.tabs = Array.from(this.querySelectorAll('.fit-day-gallery__tab'));
    this.sliderWrapper = this.querySelector('.fit-day-gallery__slider');
    this.citySelect = this.querySelector('[data-city-select]');
    this.citySelectedLabel = this.querySelector('[data-selected-label]');

    // 获取配置
    this.autoPlay = this.dataset.autoPlay === 'true';
    this.autoPlayDelay = parseInt(this.dataset.autoPlayDelay) || 5000;
  }

  initSwiper() {
    if (!this.sliderWrapper) {
      return;
    }

    // 检查 Swiper 是否已加载
    if (typeof Swiper === 'undefined') {
      console.error('Swiper.js is not loaded');

      // 尝试延迟加载
      setTimeout(() => {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          console.error('Swiper.js still not loaded after delay');
        }
      }, 100);
      return;
    }

    // 如果 Swiper 已存在，先销毁
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    const swiperOptions = {
      slidesPerView: 'auto',
      loop: true,
      speed: 500,
      resizeObserver: true,
      observeParents: true,
      centeredSlides: true,
      navigation: {
        nextEl: this.querySelector('.fit-day-gallery__nav--next'),
        prevEl: this.querySelector('.fit-day-gallery__nav--prev'),
      },
      pagination: {
        el: this.querySelector('.fit-day-gallery__pagination'),
        clickable: true,
      },
      on: {
        init: this.onSwiperInit.bind(this),
        slideChange: this.onSlideChange.bind(this),
        slideChangeTransitionEnd: this.onSlideChangeEnd.bind(this),
        resize: this.onSwiperResize.bind(this),
      }
    };

    // 添加自动播放配置
    if (this.autoPlay) {
      swiperOptions.autoplay = {
        delay: this.autoPlayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    try {
      this.swiper = new Swiper(this.sliderWrapper, swiperOptions);
      console.log('Swiper initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Swiper:', error);
    }
  }

  bindEvents() {
    // Tab 点击事件
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.swiper) {
          this.swiper.slideToLoop(index);
          this.updateTabs(index);
        }
      });
    });
    // Select 切换事件
    this.citySelect.addEventListener('change', (e) => {
      e.preventDefault();
      const index = Number(this.citySelect.value);
      this.customSelected = true;
      if (this.swiper) {
        this.swiper.slideToLoop(index);
        this.updateTabs(index);
      }
    });
  }

  onSwiperInit() {
    // 初始化后更新 Tab 状态
    if (this.swiper) {
      this.updateTabs(this.swiper.realIndex);
      this.updateSelect(this.swiper.realIndex);

      // 确保初始 Tab 在移动端可见
      if (this.isMobile && this.tabs.length > 0) {
        const activeTab = this.tabs[this.swiper.realIndex];
        if (activeTab) {
          this.scrollTabIntoView(activeTab);
        }
      }
    }
  }

  onSlideChange() {
    // 幻灯片切换时更新 Tab
    if (this.swiper) {
      this.updateTabs(this.swiper.realIndex);
      this.updateSelect(this.swiper.realIndex);
    }
  }

  onSlideChangeEnd() {
    // 幻灯片切换结束后，确保 Tab 在移动端可见
    if (this.isMobile && this.swiper && this.tabs.length > 0) {
      const activeTab = this.tabs[this.swiper.realIndex];
      if (activeTab) {
        this.scrollTabIntoView(activeTab);
      }
    }
  }

  onSwiperResize() {
    this.isMobile = window.innerWidth <= 768;
  }

  updateTabs(activeIndex) {
    // 更新所有 Tab 的激活状态
    this.tabs.forEach((tab, index) => {
      const isActive = index === activeIndex;

      tab.classList.toggle('fit-day-gallery__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

  }

  updateSelect(activeIndex) {
    // 更新 Select 的状态
    this.citySelect.value = activeIndex;
    if (this.customSelected) {
      this.citySelectedLabel.innerHTML = this.citySelect.options[Number(activeIndex)].label;
    }
  }

  scrollTabIntoView(tab) {
    if (!this.tabContainer || !tab) return;

    const containerWidth = this.tabContainer.offsetWidth;
    const tabLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;

    // 计算滚动位置使 Tab 居中
    const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);

    this.tabContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  reinitSwiper() {
    this.initSwiper();
  }

  cleanup() {
    // 清理 Swiper 实例
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  // 公共 API 方法
  nextSlide() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  goToSlide(index) {
    if (this.swiper && index >= 0 && index < this.swiper.slides.length) {
      this.swiper.slideToLoop(index);
    }
  }

  get activeIndex() {
    return this.swiper ? this.swiper.realIndex : 0;
  }

  get slidesCount() {
    return this.swiper ? this.swiper.slides.length : 0;
  }
}

if (!customElements.get('fit-day-gallery')) {
  customElements.define('fit-day-gallery', FitDayGallery);
}

/**
 * 留邮 Submit 埋点
 */
var time_interval_normal_email_fit_day = setInterval(function () {
  const submitButton = document.querySelector('.fit-day-subscribe .klaviyo-wrapper [data-testid="form-row"]:nth-child(1) button');
  if (submitButton) {
    email_submit_flag = "fail";
    clearInterval(time_interval_normal_email_fit_day);
    $(submitButton).click(function () {
      const emailInput = document.querySelector('.fit-day-subscribe .klaviyo-wrapper [data-testid="form-row"]:nth-child(1) input');
      let now_email = $(emailInput).val().trim();
      setTimeout(function () {
        const emailInput = document.querySelector('.fit-day-subscribe .klaviyo-wrapper [data-testid="form-row"]:nth-child(1) input');
        if ($(emailInput).length <= 0) {
          email_submit_flag = "success";
        }
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
          "event": "ga4Event",
          "event_name": "subscribe",
          "event_parameters": {
            "module": "shokz_fit_day_subscription",
            "content_name": "Shokz Fit Day Subscription",
            "email": now_email,
            "status": email_submit_flag
          }
        });
      }, 5000)
    });
  }
}, 500);

// Event 模块 Register 按钮埋点
$('.fit-day-events__subscribe-btn[href]').on('click', (e) => {
  /** @type {HTMLElement} */
  const el = e.currentTarget;
  const city = el.closest('.fit-day-events__card-content').querySelector('.fit-day-events__location__title')?.innerText ?? null;
  if (city) {
    console.log('GA4 Event: (Register) select_content');
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event": "ga4Event",
      "event_name": "select_content",
      "event_parameters": {
        "content_type": "Events",
        "content_name": city,
        "button_name": el.innerText,
      }
    });
  } else {
    console.error('Not found city name on ".fit-day-events__subscribe-btn"')
  }
})

// Event 模块轮播图进视图的埋点
/** @type {FitDayEvents} */
const fitDayEvents = document.querySelector('fit-day-events');
fitDayEvents.setInViewCallback(
  (slide) => {
    const cityName = slide.querySelector('.fit-day-events__location__title')?.innerText;
    console.log(`GA4 Event: fit-day-events slide (${cityName})`);
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event": "ga4Event",
      "event_name": "module_impression",
      "event_parameters": {
        "module": cityName,
      }
    });
  });

// fit-day-products 的 LearnMore 按钮的埋点
$('.fit-day-products__card__button').on('click', (e) => {
  /** @type {HTMLElement} */
  const el = e.currentTarget;
  const title = el.parentElement.querySelector('.fit-day-products__card__title .visually-hidden')?.innerText;
  console.log(`GA4 Event: fit-day-products learn more button (${title})`);
  window.dataLayer.push({ "event_parameters": null });
  window.dataLayer.push({
    "event": "ga4Event",
    "event_name": "select_content",
    "event_parameters": {
      "content_type": "Products",
      "content_name": title,
      "button_name": el.innerText,
    }
  });
});

const productsSlider = document.querySelector('fit-day-products .fit-day-products__slider');
const productsSectionObserver = createObserverToListenElementInViewport(() => {
  console.log(`GA4 Event: fit-day-products in view`);
  window.dataLayer.push({ "event_parameters": null });
  window.dataLayer.push({
    "event": "ga4Event",
    "event_name": "module_impression",
    "event_parameters": {
      "module": "Fit Day Products"
    }
  });
  productsSectionObserver.disconnect(); // 只触发一次埋点
})
productsSectionObserver.observe(productsSlider);


$('.fit-day-subscribe__card-rule__title').on('click', function () {
  if ($(window).width() <= 768) {
    var $text = $(this).next('.fit-day-subscribe__card-rule__text');

    $(this).toggleClass('active');
    $text.stop().slideToggle(300);
  }
});